// extracted by mini-css-extract-plugin
module.exports =  {"root":"ConditionSection-module__root--ItArT","titleLabel":"ConditionSection-module__titleLabel--Sd_LD","conditionLabel":"ConditionSection-module__conditionLabel--_sPoV"};